import React, { Component } from "react";
import LoginForm from "../../forms/public-pages/LoginForm";

class LoginPage extends Component {
	render() {
		return (
			<div className="centerize-container">
				<div className="table-row">
					<div className="table-cell">
						<div className="login-wrapper fadeInLoadUp">
							<h1 className="text-center"><b>TASK</b> 3.2</h1>
							<LoginForm />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/components/pages/public-pages/LoginPage.js